import { getDecisionTable } from '@/utils/analytics/reclamationInner'
function mapChartReportTypeDecision (items) {
  return items?.map(item => getDecisionTable(item))
}

export {
  mapChartReportTypeDecision
}
